import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AdmissionService } from 'src/app/private/services/admission.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-move-to-admission',
  imports: [SharedModule],
  templateUrl: './move-to-admission.component.html',
  styleUrl: './move-to-admission.component.scss'
})
export class MoveToAdmissionComponent {

  @Output() closeDialog = new EventEmitter();
  @Input() editLeadData: any = {};
  @Output() reload = new EventEmitter<any>();
  isLoading = false;
  @Input() academicYears: any[] = [];
  @Input() departments: any[] = [];
  @Input() courses: any[] = [];
  @Input() batches: any[] = [];

  selectedAcademicYear: any = null;
  selectedDepartment: any = null;
  selectedCourse: any = null;
  selectedBatch: any = null;

  constructor(
    private api: AdmissionService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    console.log("editLeadData", this.editLeadData);
    this.selectedAcademicYear = this.editLeadData.enrollment_data?.academic_year_id || null;
    this.selectedDepartment = this.editLeadData.enrollment_data?.department_id || null;
    this.selectedCourse = this.editLeadData.enrollment_data?.course_id ? parseInt(this.editLeadData.enrollment_data?.course_id) : null;
    this.selectedBatch = this.editLeadData.enrollment_data?.batch_id || null;
  }

  moveToAdmission() {
    if (!this.editLeadData) return;

    this.isLoading = true;

    const enrollment = this.editLeadData.enrollment_data || {};
    const registration = this.editLeadData.registration || {};
    const application = this.editLeadData.application_data || {};
    const lead = this.editLeadData;

    const data = {
      organization_id: this.localStorage.getOrganizationId() || lead.organization_id,
      campus_id: this.localStorage.getCampusId() || lead.campus_id,
      enrollment_id: enrollment.enrollment_id || null,
      lead_id: lead.lead_id || null,

      admission_date: enrollment.enrollment_date || new Date().toISOString(),
      academic_year_id: this.selectedAcademicYear || enrollment.academic_year_id || null,
      session: "Fall 2025",
      course_id: enrollment.course_id || application.course_id || registration.preferred_course || null,
      department_id: this.selectedDepartment || 299, // agar mapping hai to update karo
      batch_id: this.selectedBatch || 4,

      admission_status: "Under Review",
      admission_type: "Regular",
      category: "General",
      admission_source: lead.source || "Website",
      application_no: application.application_id || null,
      approved_by: this.localStorage.getUserId(),
      approved_at: new Date().toISOString(),
      remarks: lead.remarks || enrollment.remarks || "Student selected for Fall 2025 batch",

      // Student Details
      prefix: lead.prefix || lead.user?.prefix || null,
      first_name: lead.first_name || lead.user?.fname,
      last_name: lead.last_name || lead.user?.lname,
      email: lead.email || lead.user?.email,
      date_of_birth: lead.date_of_birth,
      age: lead.age,
      gender: lead.gender,
      blood_group: lead.blood_group || null,
      nationality: lead.nationality,
      address: lead.address,
      city: lead.city,
      state: lead.state,
      country: lead.country,
      postal_code: lead.postal_code,
      phone: lead.phone,
      country_code: lead.country_code,
      alternate_phone: lead.alternate_phone,

      guardian_name: registration.guardian_name,
      guardian_contact: registration.guardian_contact,
      previous_education: registration.previous_education,

      // Enrollment extra
      enrollment_number: enrollment.enrollment_number,
      assigned_to: enrollment.assign_to,
      document_status: enrollment.document_status,
      payment_status: enrollment.payment_status || { status: "Not Paid" },
      admission_mode: enrollment.mode_of_study || "Offline",
      is_student_profile: this.editLeadData.is_student_profile || false,
      dynamic_fields: this.editLeadData.dynamic_fields || {}
    };

    this.api.moveToAdmission(data).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message });
        this.reload.emit();
        this.closeDialog.emit();
      },
      error: (err) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Something went wrong' });
      }
    });
  }



  handleCloseDialog() {
    this.closeDialog.emit();
  }


  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

}
